import"./createWebStorage.js";import{__exports as e}from"../../../../_virtual/createWebStorage.js";var a,t;a=(0,((t=e)&&t.__esModule?t:{default:t}).default)("local");export{a as default};
//# sourceMappingURL=index.js.map
